import styled from 'styled-components';

export const KiosksLiveUsageHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
